import {
  CircularProgress,
  Typography,
  Container,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import { useStudentEvents } from "../../api/getStudentEvents";
import CustomTable from "../../../../ui/components/Table";
import moment from "moment";

const StudentEvents = ({ studentId }) => {
  const { data, isLoading } = useStudentEvents({ studentId });
  if (isLoading) {
    return <CircularProgress />;
  }
  return (
    <CustomTable>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography>Nome </Typography>
          </TableCell>
          <TableCell>
            <Typography>Data</Typography>
          </TableCell>
          <TableCell>
            <Typography>Status</Typography>
          </TableCell>
          <TableCell>
            <Typography>Qtd. de Logons</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {(data || []).map((event) => (
          <TableRow>
            <TableCell>
              <Typography>{event.NOME_TURMA}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{moment(event.dtinicio).format("lll")}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{event.situacao}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{event.QTD_LOGON}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </CustomTable>
  );
};

export default StudentEvents;
